import { instance } from "../constants/config";

export type AdminNotificationType =
  | "payment_declined"
  | "payment_disputed"
  | "payment_refunded"
  | "renewal_payment_due"
  | "renewal_payment_submitted"
  | "renewal_payment_overdue";

export type AdminNotificationSeverity = "info" | "warning" | "error";

export interface AdminNotificationMetadata {
  reason?: string | null;
  amount?: number | null;
  currency?: string | null;
  billingCycle?: string | null;
  attemptCount?: number | null;
  terminal?: boolean | null;
  stripeInvoiceId?: string | null;
  stripePaymentIntentId?: string | null;
  stripeSubscriptionId?: string | null;
  stripeCustomerId?: string | null;
  subscriptionCycleId?: string | null;
}

export interface AdminNotification {
  _id: string;
  type: AdminNotificationType;
  severity: AdminNotificationSeverity;
  title: string;
  message: string;
  read: boolean;
  readAt?: string | null;
  consultant?: string | null;
  consultantName?: string | null;
  consultantEmail?: string | null;
  subscription?: string | null;
  metadata: AdminNotificationMetadata;
  createdAt: string;
  updatedAt: string;
}

export interface NotificationListResponse {
  notifications: AdminNotification[];
  unreadCount: number;
  pagination: {
    page: number;
    limit: number;
    total: number;
    hasMore: boolean;
  };
}

export const fetchNotifications = async (
  status: "unread" | "all" = "all",
  limit = 20,
  page = 1
): Promise<NotificationListResponse> => {
  const response = await instance.get("/api/admin/notifications", {
    params: { status, limit, page },
  });
  return response.data;
};

export const fetchUnreadCount = async (): Promise<number> => {
  const response = await instance.get("/api/admin/notifications/unread-count");
  return response.data?.unreadCount ?? 0;
};

export const markNotificationRead = async (
  id: string
): Promise<{ unreadCount: number }> => {
  const response = await instance.patch(`/api/admin/notifications/${id}/read`);
  return response.data;
};

export const markAllNotificationsRead = async (): Promise<{
  unreadCount: number;
}> => {
  const response = await instance.patch("/api/admin/notifications/read-all");
  return response.data;
};
